import React from "react";
import { DataTable } from "primereact/datatable";

export const TableModalGroupByClients = (props) => (
  <DataTable
    value={props.records}
    emptyMessage="Não foram encontrados registros" 
    scrollable={true}
    scrollHeight={"150px"} 
  >
    {props.columns}
  </DataTable>
);
